"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview28_exports = {};
__export(GeodesPreview28_exports, {
  default: () => GeodesPreview28_default
});
module.exports = __toCommonJS(GeodesPreview28_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 21",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.66016 2.75C4.20443 2.75 3.8138 2.91276 3.48828 3.23828C3.16276 3.5638 3 3.95443 3 4.41016V7.75C3 8.20573 3.16276 8.59635 3.48828 8.92188C3.8138 9.2474 4.20443 9.41016 4.66016 9.41016H16.3398C16.7956 9.41016 17.1862 9.2474 17.5117 8.92188C17.8372 8.59635 18 8.20573 18 7.75V4.41016C18 3.95443 17.8372 3.5638 17.5117 3.23828C17.1862 2.91276 16.7956 2.75 16.3398 2.75H4.66016ZM3 12.75C3 12.2943 3.16276 11.9036 3.48828 11.5781C3.8138 11.2526 4.20443 11.0898 4.66016 11.0898H8C8.45573 11.0898 8.84635 11.2526 9.17188 11.5781C9.4974 11.9036 9.66016 12.2943 9.66016 12.75V16.0898C9.66016 16.5456 9.4974 16.9362 9.17188 17.2617C8.84635 17.5872 8.45573 17.75 8 17.75H4.66016C4.20443 17.75 3.8138 17.5872 3.48828 17.2617C3.16276 16.9362 3 16.5456 3 16.0898V12.75ZM13 11.0898C12.5443 11.0898 12.1536 11.2526 11.8281 11.5781C11.5026 11.9036 11.3398 12.2943 11.3398 12.75V16.0898C11.3398 16.5456 11.5026 16.9362 11.8281 17.2617C12.1536 17.5872 12.5443 17.75 13 17.75H16.3398C16.7956 17.75 17.1862 17.5872 17.5117 17.2617C17.8372 16.9362 18 16.5456 18 16.0898V12.75C18 12.2943 17.8372 11.9036 17.5117 11.5781C17.1862 11.2526 16.7956 11.0898 16.3398 11.0898H13ZM0.5 1.91016V18.5898C0.5 19.0456 0.66276 19.4362 0.988281 19.7617C1.3138 20.0872 1.70443 20.25 2.16016 20.25H18.8398C19.2956 20.25 19.6862 20.0872 20.0117 19.7617C20.3372 19.4362 20.5 19.0456 20.5 18.5898V1.91016C20.5 1.45443 20.3372 1.0638 20.0117 0.738281C19.6862 0.41276 19.2956 0.25 18.8398 0.25H2.16016C1.70443 0.25 1.3138 0.41276 0.988281 0.738281C0.66276 1.0638 0.5 1.45443 0.5 1.91016ZM2.16016 1.08984H18.8398C19.0612 1.08984 19.25 1.17448 19.4062 1.34375C19.5755 1.5 19.6602 1.6888 19.6602 1.91016V18.5898C19.6602 18.8112 19.5755 19 19.4062 19.1562C19.25 19.3255 19.0612 19.4102 18.8398 19.4102H2.16016C1.9388 19.4102 1.74349 19.3255 1.57422 19.1562C1.41797 19 1.33984 18.8112 1.33984 18.5898V1.91016C1.33984 1.6888 1.41797 1.5 1.57422 1.34375C1.74349 1.17448 1.9388 1.08984 2.16016 1.08984Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview28 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview28_default = SvgGeodesPreview28;
